import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../../components/table/ResultTable";
import ResultText from "../ResultText";
import ComparisonCSName from "../ComparisonCSName";
import {useModal} from "../../../context/ModalContext";
import EmptyLine from "../EmptyLine";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultBody from "../../../components/table/ResultBody";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function C2({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    const {openModal} = useModal()

    switch (row.error_id) {
        case MessageCodes.Compare.SEC001.error_id: {
            return (
                <>
                    <ResultText>
                        There is a difference in the topography (Station/Elevation data) of the following {Array.from(new Set(row.data?.map(x => x.cross_section)))?.length} cross sections:
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => ({
                            csName: x.cross_section,
                            csNameVal: x.cross_section,
                        }))} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.SEC002.error_id: {
            const cs_list = Array.from(new Set(row?.data?.map(x => x.cross_section)))
            return (
                <>
                    <ResultText>
                        The differences in the topography (Station/Elevation data) of the following {Array.from(new Set(row.data?.map(x => x.cross_section)))?.length} cross sections are significant and likely to cause some difference in the WSEL for the listed profiles. The percentage values in the table denote the change in flow area at the cross section for the listed profile.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(40)}}>Profile</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                cs_list?.map(cs => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>
                                            <ComparisonCSName csName={cs} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'left', width: HecRasHelper.getWidth(40)}}>
                                            {row?.data?.filter(x => x.cross_section === cs).map(x => `${x.profile} (${x.diff} %)`).join(', ')}
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.SECICS001.error_id: {
            return (
                <>
                    <ResultText>
                        There is a difference in the topography (Station/Elevation data) of the following {Array.from(new Set(row.data?.map(x => x.cross_section)))?.length} Internal Bridge Cross Sections:
                    </ResultText>
                    <ResultText>
                        <ComparisonCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}